import React, { useRef } from 'react'
import { Modal, Button, message } from 'antd'

const HEADERS = ['Lô', 'Barcode item', 'SKU / Size', 'Màu chỉ trên QR (đã in)', 'Màu chỉ cần dùng khi may']

function buildTsv(items) {
    const rows = items.map(i => [
        i.batch_name,
        i.barcode,
        `${i.sku} / ${i.size}`,
        `${i.printed_label} · ${i.printed}`,
        `${i.current_label} · ${i.current}`,
    ].join('\t'))
    return [HEADERS.join('\t'), ...rows].join('\n')
}

function SewingThreadCopyModal({ visible, items, onClose }) {
    const _textarea = useRef()
    const tsv = buildTsv(items)

    const handleCopy = () => {
        const el = _textarea.current
        el.select()
        el.setSelectionRange(0, 99999)
        document.execCommand('copy')
        onClose()
        message.success('Đã copy vào clipboard')
    }

    return (
        <Modal
            title="Danh sách item lệch màu chỉ — chọn toàn bộ và copy"
            visible={visible}
            onCancel={onClose}
            width={800}
            footer={[
                <Button key="copy" type="primary" onClick={handleCopy}>Copy</Button>
            ]}
        >
            <textarea
                ref={_textarea}
                className="SewingThreadCopyTextarea"
                readOnly
                value={tsv}
                style={{ width: '100%', height: 220, fontFamily: 'monospace' }}
                onClick={e => e.target.select()}
            />
            <p className="text-muted mt-2 mb-0">
                Định dạng TSV — dán thẳng vào Excel hoặc Google Sheets sẽ tự tách cột.
            </p>
        </Modal>
    )
}

export default SewingThreadCopyModal
